// removed by extract-text-webpack-plugin
module.exports = {"black":"color__black___2f0FY c-black","steel":"color__steel___GLivr c-steel","slate":"color__slate___2QNtV c-slate","silver":"color__silver___SQdt4 c-silver","smoke":"color__smoke___1donP c-smoke","darkSmoke":"color__darkSmoke___EMWmi c-smoke--d","extraDarkSmoke":"color__extraDarkSmoke___N7rNo c-smoke--xd","snow":"color__snow___trnRi c-snow","darkSnow":"color__darkSnow___1MI_7 c-snow--d","extraDarkSnow":"color__extraDarkSnow___3Hnvc c-snow--xd","white":"color__white___2-otW c-white"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-heading/Heading/style/color.css
// module id = 161
// module chunks = 0 21